<template lang="pug">
  .component-transaction-list-filter-form.filter-form
    .entity-filters(v-if="$is('entity-filter')")
      select(v-model="search.status", v-on:change="filterTransactions").medium-5
        option(:value="null" selected) All statuses
        option(value="SUCCESS") Success
        option(value="FAILED") Failed
        option(value="NEW") New
        option(value="HARD FAILED") Hard failed
        option(value="SOFT FAILED") Soft Failed
    .row.medium-unstack(v-else="")
      .columns.large-3
        selectize-client(@optionSelected="selectClient")
      .columns.large-3
        date-range-picker(@input="dateRangeSelected")
      .columns.large-2
        select(v-model="search.status")
          option(value="" selected) All statuses
          option(value="SUCCESS") Success
          option(value="FAILED") Failed
          option(value="NEW") New
          option(value="HARD FAILED") Hard failed
          option(value="SOFT FAILED") Soft Failed
      .columns.large-2
        select(v-model="search.type")
          option(value="" selected) All types
          option(value="INBOUND") Inbound
          option(value="OUTBOUND") Outbound
      .columns.large-1
        a.fa.fa-angle-double-down.fa-2x(v-on:click="filterTransactions")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import SelectizeClient from '../lists/selectize/SelectizeClient'
  import DateRangePicker from "../../DateRangePicker.vue";

  export default {
    name: 'TransactionListForm',
    components: {
      DateRangePicker,
      SelectizeClient,
      KeplerBackofficeSdk,
    },
    data() {
      return {
        clients: [],
        search: {
          client_id: null,
          date_from: null,
          date_to: null,
          status: null,
          type: null
        }
      }
    },
    mounted() {

    },
    methods: {
      setRange(range) {
        this.search.date_from = range.from
        this.search.date_to = range.to
      },
      selectClient(client) {
        this.search.client_id = client.id
      },
      filterTransactions() {
        var search = {}

        // client empty values for prevent backoffice validation errors
        $.map(this.search, function (value, key) {
          if (value !== null && value !== '') {
            search[key] = value
          }
        })

        this.$emit('filterTransactions', search)
      },
      dateRangeSelected(range) {
        this.search.date_from = range.start
        this.search.date_to = range.end
      },
    },
    computed: {},
    props: {
      type: {
        type: String,
        default: ''
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// TransactionListForm.vue?64719a92